/* ============================================================
   GOOTER Upsells - Ajax Cart-Add + Section-Re-Render
   Keine externe Library, kein jQuery.
   Event-Delegation auf document, idempotent.
   ============================================================ */
(function () {
  'use strict';

  if (window.GooterUpsellsBound) return;
  window.GooterUpsellsBound = true;

  var t = function (k, fb) {
    var dict = (window.GooterUpsellStrings) || {};
    return (dict[k] !== undefined ? dict[k] : (fb !== undefined ? fb : k));
  };

  function rootPath() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getCart() {
    return fetch(rootPath() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function tracking(eventName, payload) {
    try {
      if (window.dataLayer && Array.isArray(window.dataLayer)) {
        var p = Object.assign({ event: eventName }, payload || {});
        window.dataLayer.push(p);
      }
      window.dispatchEvent(new CustomEvent('gooter:upsell:' + eventName.replace(/^gooter_upsell_/, ''), { detail: payload || {} }));
    } catch (e) { /* noop */ }
  }

  /* --- Section-IDs sammeln zum Re-Rendern -------------------- */

  function getSectionsToRerender() {
    var sections = [];
    // Cart-Drawer Custom-Element
    var drawer = document.querySelector('cart-drawer');
    if (drawer) sections.push('cart-drawer');
    // Header Cart-Icon
    if (document.querySelector('#cart-icon-bubble')) sections.push('cart-icon-bubble');
    // Cart-Page Items
    if (document.querySelector('#main-cart-items')) {
      var sec = document.querySelector('#main-cart-items');
      var id = sec.getAttribute('data-id');
      if (id) sections.push(id);
    }
    // Cart-Page Footer
    if (document.querySelector('#main-cart-footer')) {
      var f = document.querySelector('#main-cart-footer');
      var fid = f.getAttribute('data-id');
      if (fid) sections.push(fid);
    }
    // GOOTER Cart-Upsells Sektion
    document.querySelectorAll('.gooter-cart-upsells-section').forEach(function (s) {
      var sid = s.getAttribute('data-section-id') || s.id || '';
      if (sid) sections.push(sid.replace(/^shopify-section-/, ''));
    });
    return sections;
  }

  /* --- Section-HTML aus API-Antwort in DOM injizieren -------- */

  function applyRenderedSections(sections) {
    if (!sections || typeof sections !== 'object') return;
    Object.keys(sections).forEach(function (sid) {
      var html = sections[sid];
      if (!html) return;
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var srcId = 'shopify-section-' + sid;
      var src = doc.getElementById(srcId);
      var tgt = document.getElementById(srcId);
      if (src && tgt) {
        tgt.innerHTML = src.innerHTML;
      } else {
        // Fallback fuer cart-drawer / cart-icon-bubble (Custom Elements)
        if (sid === 'cart-drawer') {
          var srcDrawer = doc.querySelector('cart-drawer');
          var tgtDrawer = document.querySelector('cart-drawer');
          if (srcDrawer && tgtDrawer) {
            tgtDrawer.innerHTML = srcDrawer.innerHTML;
          }
        }
        if (sid === 'cart-icon-bubble') {
          var srcBubble = doc.getElementById('cart-icon-bubble');
          var tgtBubble = document.getElementById('cart-icon-bubble');
          if (srcBubble && tgtBubble) {
            tgtBubble.innerHTML = srcBubble.innerHTML;
          }
        }
      }
    });
  }

  /* --- Add-to-Cart per Ajax + Section-Rendering ------------- */

  function addToCart(card) {
    var btn = card.querySelector('[data-gooter-upsell-add]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    var handle = btn.getAttribute('data-product-handle');
    var title = btn.getAttribute('data-product-title') || handle;
    var placement = card.getAttribute('data-placement') || 'cart_drawer';
    var section_kind = card.getAttribute('data-section-kind') || 'primary';

    btn.setAttribute('aria-busy', 'true');

    var sections = getSectionsToRerender();
    var body = {
      items: [{ id: variantId, quantity: 1 }]
    };
    if (sections.length > 0) {
      body.sections = sections.join(',');
      body.sections_url = window.location.pathname;
    }

    tracking('gooter_upsell_click', {
      section: section_kind,
      placement: placement,
      product_handle: handle,
      product_title: title,
      variant_id: variantId
    });

    fetch(rootPath() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) { return r.json().then(function (j) { throw new Error(j.description || 'Add failed'); }); }
        return r.json();
      })
      .then(function (data) {
        // Success animation
        var label = btn.querySelector('[data-add-label]');
        if (label) label.textContent = t('added', 'Hinzugefuegt');
        btn.setAttribute('aria-busy', 'false');
        card.classList.add('is-added');

        tracking('gooter_upsell_add_to_cart', {
          section: section_kind,
          placement: placement,
          product_handle: handle,
          product_title: title,
          variant_id: variantId
        });

        // Apply rendered sections to DOM (cart-drawer etc.)
        if (data.sections) {
          applyRenderedSections(data.sections);
          // Cart-Drawer offen halten
          var cd = document.querySelector('cart-drawer');
          if (cd && typeof cd.open === 'function') {
            // dont auto-close on add
          }
        }

        // Hard-Remove die Karte nach Animation
        setTimeout(function () {
          card.remove();
          // Wenn beide Sections leer sind, ganzen Wrapper verstecken
          document.querySelectorAll('.gooter-upsell').forEach(function (sec) {
            if (sec.querySelectorAll('[data-gooter-upsell-card]').length === 0) {
              sec.style.display = 'none';
            }
          });
        }, 600);

        // PubSub fuer Dawn-Cart-Komponenten
        try {
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'gooter-upsells',
              productVariantId: variantId,
              cartData: data
            });
          }
        } catch (e) { /* noop */ }
      })
      .catch(function (err) {
        btn.setAttribute('aria-busy', 'false');
        var existingErr = card.querySelector('.gooter-upsell-error');
        if (!existingErr) {
          var errDiv = document.createElement('div');
          errDiv.className = 'gooter-upsell-error';
          errDiv.setAttribute('role', 'alert');
          errDiv.textContent = t('error', 'Produkt konnte nicht hinzugefuegt werden.');
          card.appendChild(errDiv);
          setTimeout(function () { errDiv.remove(); }, 4000);
        }
        console.error('[gooter-upsells]', err);
      });
  }

  /* --- Event-Delegation -------------------------------------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-gooter-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('[data-gooter-upsell-card]');
    if (card) addToCart(card);
  });

  /* --- Impression-Tracking (1x pro Pageview) ---------------- */

  function trackImpressions() {
    document.querySelectorAll('[data-gooter-upsell-card]').forEach(function (card) {
      if (card.__impressed) return;
      card.__impressed = true;
      tracking('gooter_upsell_impression', {
        section: card.getAttribute('data-section-kind') || 'primary',
        placement: card.getAttribute('data-placement') || 'cart_drawer',
        product_handle: card.getAttribute('data-product-handle'),
        variant_id: card.getAttribute('data-variant-id')
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackImpressions);
  } else {
    trackImpressions();
  }

  // Bei Cart-Drawer-Re-Render: neue Karten registrieren
  document.addEventListener('shopify:section:load', trackImpressions);
  window.addEventListener('gooter:cart:updated', trackImpressions);
})();
